import { __makeTemplateObject } from 'tslib';
import { createGlobalStyle } from 'styled-components';

var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    margin: 0;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: border-box;\n  }\n"], ["\n  body {\n    margin: 0;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: border-box;\n  }\n"])));
var templateObject_1;

export { GlobalStyle };
//# sourceMappingURL=GlobalStyle.js.map
